import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faCreditCard, faUser, faUsers, faCircleNotch, faArrowRight} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate, Link, useLocation } from 'react-router-dom'
function Enrollment3() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [disable, setDisable] = useState(true);
  const [employer_id, setEmployer_id] = useState(state?.employer_id ?? localStorage.getItem('user.employer_id') ?? '');
  const [age, setAge] = useState(state?.age ?? localStorage.getItem('user.age') ?? '');
  const [contribution, setContribution] = useState(state?.contribution ?? localStorage.getItem('user.contribution') ?? '');
  const [salary, setSalary] = useState(state?.salary ?? localStorage.getItem('user.salary') ?? '');
  const [tax_type, setTax_type] = useState(state?.tax_type ?? localStorage.getItem('user.tax_type') ?? 'Pre-tax');
  const [effective_date, setEffective_date] = useState(state?.effective_date ?? localStorage.getItem('user.effective_date') ?? 'false');
  const [investment, setInvestment] = useState(state?.investment ?? localStorage.getItem('user.investment') ?? 'target');
  const [stocks, setStocks] = useState(state?.stocks ?? localStorage.getItem('user.stocks') ?? 60);
  const [bonds, setBonds] = useState(state?.bonds ?? localStorage.getItem('user.bonds') ?? 30);
  const [cash, setCash] = useState(state?.cash ?? localStorage.getItem('user.cash') ?? 10);
  const [relationship, setRelationship] = useState(state?.relationship ?? localStorage.getItem('user.relationship') ?? 'Spouse');
  const [share, setShare] = useState(state?.share ?? localStorage.getItem('user.share') ?? 100);
  const [beneficiary_name, setBeneficiary_name] = useState(state?.beneficiary_name ?? localStorage.getItem('user.beneficiary_name') ?? '');
  const [email, setEmail] = useState(localStorage.getItem('user.email') ?? '');
  const [userDetails, setUserDetails] = useState([]);
  useEffect(() => {
    if(!investment || !stocks || !bonds || !cash){
        navigate('/enrollment2', { replace: true });
    }else{
        setLoading(false)
    }
  }, [email]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchuser1: true, email: email})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success" && data.user) {
            setUserDetails(data.user);
            setLoading(false);
        } else {
            setLoading(true);
        }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }, [email]);
  useEffect(() => {
    if(relationship && share && beneficiary_name){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [relationship, share, beneficiary_name]);

  if (loading || !userDetails || typeof userDetails !== 'object' || Object.keys(userDetails).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
    <div><Toaster/></div>
    <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
        Back to homepage
        </Link>
    </header>
    <main>
        <div className="container mt-5">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 mb-5">
                    <h5 className="mb-0" style={{fontWeight:'900'}}>401(k) Enrollment</h5>
                    <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                      <Link to="/enrollment" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                          <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Personal</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment1" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Contributions</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment2" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Investment</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment3" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faUsers} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Beneficiary</p>
                      </Link>
                      <div style={{height:'3px',maxWidth:'200px',backgroundColor:'#ffffff0c',width:'100%'}}></div>
                      <Link to="/enrollment4" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review</p>
                      </Link>
                    </div>
                    <div className="mycard p-3 mt-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Primary beneficiary name</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="Beneficiary name"
                                        value={beneficiary_name}
                                        onChange={(e) => setBeneficiary_name(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Relationship</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="Relationship"
                                        value={relationship}
                                        onChange={(e) => setRelationship(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Share %</label>
                                    <input
                                        type="number"
                                        className="form-control py-2"
                                        placeholder="Share %"
                                        value={share}
                                        onChange={(e) => setShare(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                        {disable ? (
                            <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                        ) : (
                            <Link to="/enrollment4" state={{employer_id:employer_id, email:email, age:age, effective_date:effective_date, tax_type:tax_type, contribution:contribution, salary:salary, investment:investment, stocks:stocks, bonds:bonds, cash:cash, beneficiary_name:beneficiary_name, relationship:relationship, share:share}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => { 
                                localStorage.setItem('user.beneficiary_name', beneficiary_name);
                                localStorage.setItem('user.relationship', relationship);
                                localStorage.setItem('user.share', share);
                            }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </div>
  )
}

export default Enrollment3